<template>
  <v-container fluid>
    <v-row align="center" justify="center" v-if="routeName == 'changepassword'">
      <v-col
        v-if="checkToken"
        cols="12"
        lg="8"
        md="8"
        class="fill-height d-flex flex-column justify-center align-center"
      >
        <v-form ref="form" style="width: 100%">
          <v-card style="width: 100%">
            <v-card-title class="justify-center align-center"> </v-card-title>
            <v-card-text class="body-1">
              <br />
              <passwordForm
                @emitPassword="emitPassword"
                @emitConfirmation="emitConfirmation"
              />
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" text @click="resetPassword">
                {{ $t('button.confirm') }}
              </v-btn>
              <v-btn
                text
                :to="{
                  name: 'Login',
                  params: { namespaceonly: true },
                }"
              >
                {{ $t('button.cancel') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
      <v-card v-if="!checkToken">
        <v-card-title>
          {{ $t('password.expire.title') }}
        </v-card-title>
        <v-card-text>
          {{ $t('password.expire.text') }}
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            :to="{
              name: 'Login',
              params: { namespaceonly: true },
            }"
          >
            {{ $t('button.accueil') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-row>
    <v-row
      align="center"
      justify="center"
      v-else-if="routeName == 'reinitpassword'"
    >
      <v-col
        v-if="checkToken"
        cols="12"
        lg="8"
        md="8"
        class="fill-height d-flex flex-column justify-center align-center"
      >
        <v-form ref="form" style="width: 100%">
          <v-card style="width: 100%">
            <v-card-title class="justify-center align-center"> </v-card-title>
            <v-card-text class="body-1">
              <br />
              <passwordForm
                @emitPassword="emitPassword"
                @emitConfirmation="emitConfirmation"
              />
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" text @click="resetPassword">
                {{ $t('button.confirm') }}
              </v-btn>
              <v-btn
                text
                :to="{
                  name: 'Login',
                  params: { namespaceonly: true },
                }"
              >
                {{ $t('button.cancel') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
      <v-card v-if="!checkToken">
        <v-card-title>
          {{ $t('password.expire.title') }}
        </v-card-title>
        <v-card-text>
          {{ $t('password.expire.text') }}
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            :to="{
              name: 'Login',
              params: { namespaceonly: true },
            }"
          >
            {{ $t('button.accueil') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import ErrorServeur from '@/plugins/mixins/ErrorServeur'
import PasswordForm from '@/view/Forgot/PasswordForm'
import toasted from '@/utils/toasted'
import Api from '@/utils/api'

export default {
  props: {
    routeName: {
      type: String,
      required: true,
    },
  },
  beforeCreate() {
    new Api('/resetPassword/token', '/oauth')
      .post({}, { params: { token: this.$route.query.token } })
      .then((response) => {
        this.checkToken = response.body
      })
      .catch((errors) => {
        this.errorsHandler(errors)
      })
  },
  components: {
    passwordForm: PasswordForm,
  },
  mixins: [ErrorServeur],
  data() {
    return {
      password: null,
      confirmation: null,
      checkToken: false,
    }
  },
  created() {},
  mounted() {},
  computed: {
    token() {
      return this.$route.query.token
    },
  },
  watch: {},
  methods: {
    emitPassword(value) {
      this.password = value
    },

    emitConfirmation(value) {
      this.confirmation = value
    },

    getForms() {
      return [this.$refs.form]
    },

    __validerForm() {
      this.resetErreur()
      try {
        const ok = this.$refs.form.validate()
        return ok
      } catch (e) {
        return false
      }
    },

    resetPassword() {
      //lance la validation
      const ok = this.__validerForm()
      if (ok) {
        let uri = ''
        if (this.routeName == 'changepassword') {
          uri = '/savePassword'
        } else if (this.routeName == 'reinitpassword') {
          uri = '/reinitpassword'
        }
        this.$api(uri, '/oauth')
          .post({
            token: this.token,
            password: this.password,
            passwordConfirm: this.confirmation,
          })
          .then((response) => {
            this.question = response.body
            if (this.routeName == 'changepassword') {
              toasted.info(this.$t('forgot.confirmationMailSent'))
            } else {
              toasted.info(this.$t('forgot.confirmationChange'))
            }
            this.$router.push({ name: 'Login' })
          })
          .catch((errors) => {
            this.errorsHandler(errors)
          })
      }
    },
  },
  validations: {},
}
</script>
